import { render, staticRenderFns } from "./PanelDemo.vue?vue&type=template&id=02a01228&scoped=true&"
import script from "./PanelDemo.vue?vue&type=script&lang=js&"
export * from "./PanelDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a01228",
  null
  
)

export default component.exports